// frontend/src/components/ThemeToggleButton.js
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTheme } from '../authSlice';
import { Sun, Moon, Monitor } from 'react-feather';
import { Button } from 'react-bootstrap';

const THEME_MODES = ['light', 'dark', 'system'];
const ICONS = {
    light: <Sun size={16} />,
    dark: <Moon size={16} />,
    system: <Monitor size={16} />
};

function ThemeToggleButton() {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.auth.theme);

  const toggleTheme = () => {
    const currentIndex = THEME_MODES.indexOf(currentTheme);
    const nextIndex = (currentIndex + 1) % THEME_MODES.length;
    dispatch(setTheme(THEME_MODES[nextIndex]));
  };

  return (
    <Button 
      variant="outline-secondary" 
      onClick={toggleTheme} 
      className="d-flex align-items-center justify-content-center"
      style={{ width: '40px', height: '40px', borderRadius: '50%' }}
      title={`Change theme (current: ${currentTheme})`}
    >
      {ICONS[currentTheme]}
    </Button>
  );
}

export default ThemeToggleButton;